export const promiseFromEvent = (target, name) => {
    return new Promise(resolve => {
        const handler = (...args) => {
            target.removeEventListener(name, handler);
            if (Array.isArray(args) && args.length === 1)
                resolve(args[0]);
            else
                resolve(args);
        };
        target.addEventListener(name, handler);
    });
};
